import React, { useState } from 'react';
import SplitSection from './SplitSection';
import './LandingSplit.css';
import performanceCandies from '../assets/newCandy.PNG';
import athleticClothing from '../assets/newAthletic.jpeg';
import aboutSambas from '../assets/aboutSambas.png';

function LandingSplit() {
  const [hoveredSide, setHoveredSide] = useState(null);

  return (
    <div className="landing-split-container" data-hovered={hoveredSide}>
      <div className="split-wrapper">
        <SplitSection
          title="Performance Candies"
          subtitle="Energy & Taste Redefined"
          imageSrc={performanceCandies}
          href="/candy"
          side="left"
          imagePosition="70% 40%"
          mobileImagePosition="center 60%"
          isHovered={hoveredSide === 'left' ? true : hoveredSide === 'right' || hoveredSide === 'center' ? false : null}
          onHover={(isHovered) => setHoveredSide(isHovered ? 'left' : null)}
        />
      </div>

      <div className="split-wrapper">
        <SplitSection
          title="Athletic Wear"
          subtitle="Streetwear Performance"
          imageSrc={athleticClothing}
          href="/apparel"
          side="center"
          showFullImage={true}
          isHovered={hoveredSide === 'center' ? true : hoveredSide === 'left' || hoveredSide === 'right' ? false : null}
          onHover={(isHovered) => setHoveredSide(isHovered ? 'center' : null)}
        />
      </div>

      <div className="split-wrapper">
        <SplitSection
          title="About Sambas & More"
          subtitle="Our Story"
          imageSrc={aboutSambas}
          href="/about"
          side="right"
          buttonText="Learn More"
          isHovered={hoveredSide === 'right' ? true : hoveredSide === 'left' || hoveredSide === 'center' ? false : null}
          onHover={(isHovered) => setHoveredSide(isHovered ? 'right' : null)}
        />
      </div>
    </div>
  );
}

export default LandingSplit;
